import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'core-js/modules/web.url-search-params';

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
//import registerServiceWorker from "./registerServiceWorker";

ReactDOM.render(<App />, document.getElementById("precag"));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js